import { useEffect, useRef, useState } from "react";
import { countryAPI } from "../../api/countryAPI";

export default function CountryTypeSearch({ setCountryCode, setCountryName, pcode }) {
    const isFirstRender = useRef(false);

    const [countryTypes, setCountryTypes] = useState([]);

    const getCountryTypes = (searchKey = '') => {
        countryAPI.getAllCountryDetails(searchKey).then((data) => {
            setCountryTypes(data);
        })
    }

    const handleowClick = (code, name) => {
        setCountryCode(code);
        setCountryName(name);
    }

    useEffect(() => {
        if (!isFirstRender.current) {
            isFirstRender.current = true;
            getCountryTypes()
        }
    }, [])

    return (
        <div className="modal fade" id="modalCountryTypeSearch">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Country</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div className="modal-body">
                        <input type="text" className="form-control" placeholder="Search by code or name"
                            onChange={(e) => getCountryTypes(e.target.value)} />
                        <table className="table mt-1">
                            <thead className="thead--color">
                                <tr>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {countryTypes && countryTypes.map(data => (
                                    <tr key={data.code}>
                                        <td>{data.code}</td>
                                        <td>{data.name}</td>
                                        <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                            onClick={() => handleowClick(data.code, data.name)} data-bs-dismiss="modal">
                                            Select</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}